import React from 'react';
import { Button } from '@mui/material';

/**
 * Btn mirrors common-ui AbstractElements Btn API (attrBtn) for compatibility.
 * attrBtn: { color, size, disabled, onClick, className, ...muiButtonProps }
 */
export default function Btn({ attrBtn = {}, children, ...rest }) {
  const { color = 'primary', size = 'medium', disabled, onClick, className, ...muiProps } = attrBtn;
  return (
    <Button
      variant="contained"
      color={color === 'secondary' ? 'secondary' : 'primary'}
      size={size}
      disabled={disabled}
      onClick={onClick}
      className={className}
      {...muiProps}
      {...rest}
    >
      {children}
    </Button>
  );
}
